<template>
  <div class="layer-tem">
    <!-- 关闭按钮 -->
    <img 
        :src="newClose"
        class="close-btn" 
        alt=""
        @click="closeLayer"
    >
    <!-- 下拉框 -->
    <div class="select-wrap">
        <div>
            <Select 
                v-model="areaId"
                transfer 
                :word-wrap="true"
                clearable
                style="width: 100px;margin-right: 10px;"
                placeholder="全部区域"
                @on-change="formChange"
            >
                <Option
                v-for="item in areaArr"
                :value="item.sid"
                :key="item.id">
                {{ item.name }}
                </Option>
            </Select>
            <Select 
                v-model="industId"
                transfer 
                :word-wrap="true"
                clearable
                style="width: 100px;"
                placeholder="全部行业"
                @on-change="formChange"
            >
                <Option
                v-for="item in industArr"
                :value="item.value"
                :key="item.id">
                {{ item.name }}
                </Option>
            </Select>
        </div>
        <div>
            <Select 
                v-model="timeIndex"
                transfer 
                :word-wrap="true"
                style="width: 100px;"
                @on-change="formChange"
            >
                <Option
                v-for="item in timeArr"
                :value="item.index"
                :key="item.index">
                {{ item.text }}
                </Option>
            </Select>
        </div>
    </div>
    <!-- 标题 -->
    <div class="tit">
        {{tableTit}}
    </div>
    <!-- 列表 滚动加载更多 -->
    <div class="table-wrap">
        <div class="table-head">
            <table>
                <tr>
                    <th width="5%">
                        序号
                    </th>
                    <th width="30%">
                        单位名称
                    </th>
                    <th width="20%">
                        所属区域
                    </th>
                    <th width="20%">
                        单位类别
                    </th>
                    <!-- <th width="10%" v-if="tableTit == '巡查完成率'">
                        检查周期
                    </th> -->
                    <th width="10%">
                        {{tableTit == '隐患数量'? '隐患数量' : '总数'}}
                    </th>
                    <th width="10%" v-if="tableTit != '隐患数量'">
                        完成数
                    </th>
                    <th width="10%">
                        详情
                    </th>
                </tr>
            </table>
        </div>
        <div class="table-body" id="rightTop">
            <table>
                <tr v-for="(item, index) in tableList" :key="index">
                    <td width="5%">
                        {{index+1}}
                    </td>
                    <td width="30%">
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.orgName"
                            v-if="item.orgName"
                        >
                            {{item.orgName}}
                        </Poptip>
                    </td>
                    <td width="20%">
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.areaName"
                            v-if="item.areaName"
                        >
                            {{item.areaName}}
                        </Poptip>
                    </td>
                    <td width="20%">
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.industryTypeName"
                            v-if="item.industryTypeName"
                        >
                            {{item.industryTypeName}}
                        </Poptip>
                    </td>
                     <!-- <td width="10%" v-if="tableTit == '巡查完成率'">
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.planPeriodTypeName"
                            v-if="item.planPeriodTypeName"
                        >
                            {{item.planPeriodTypeName}}
                        </Poptip>
                    </td> -->
                    <td width="10%">
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.total"
                        >
                            {{item.total}}
                        </Poptip>
                    </td>
                    <td width="10%" v-if="tableTit != '隐患数量'">
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.done"
                        >
                            {{item.done}}
                        </Poptip>
                    </td>
                    <td width="10%">
                        <span class="viewDetail" @click="showDetailLayer(item.orgId,item)">查看</span>
                    </td>
                </tr>
            </table>
            <p class="no-data" v-show="!tableList.length && getTableStatus">
                暂无数据
            </p>
        </div>
    </div>
  </div>
</template>
<script>
import newClose from '@/assets/img/newClose.png';
export default {
  name:"",    
  data: () => ({
    newClose,
    industArr: [],
    industId: '',
    areaArr: [],
    areaId: '',
    getTableStatus: false,
    tableList: [],
    totalCount: '',
    currentPage: 1,
    hashValue: '',
    loginData: {},
    timeArr: [
        {
            text: '今日',
            index: 0,
        },
        {
            text: '本周',
            index: 1,
        },
        {
            text: '本月',
            index: 2,
        },
    ],
    timeIndex: 0,
    tableTit: '',
  }),
  watch: {
    navName: {
        handler(newVal, oldVal){
            this.tableTit = newVal;
            this.areaId = '';
            this.industId = '';
            this.timeIndex = this.$store.state.headDate.index;
            this.tableList = [];
            this.totalCount = '';
            this.currentPage = 1;
            this.getTable();
        },
        // immediate: true,
        deep: true,
    }
  },
  components: {

  },
  created() {
    this.hashValue = localStorage.getItem('hashValue');
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.timeIndex = this.$store.state.headDate.index;
    this.getAreaData();
    this.getIndustData();
    // 标题， 根据标题请求数据
    this.tableTit = this.$store.state.showLayer.navIndex;
  },
  mounted() {
    this.getTable();
  },
  computed: {
    navName(){
        return this.$store.state.showLayer.navIndex;
    }
  },
  methods: {
    showDetailLayer(id, item){ //显示详情弹窗
      this.$store.commit('baseInfoLayer', {
        detailStatus: true,
        baseInfoId: id,
        baseInfoItem: item
      });
    },
    closeLayer(){
      this.$store.commit('showLayer', {
          status: false,
          type: '',
      });
    },
    formChange(){
        this.tableList = [];
        this.totalCount = '';
        this.currentPage = 1;
        this.getTable();
    },
    getAreaData(){
      let dataObj = {
            type: 'get',
            // url: '/mcbw/areas/' + this.loginData.orgId,
            url: '/mcbw/departments/org/area',
            obj: {
              pageSize: 1000,
              currentPage: 1,
            }
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('区域数据');
            if(res.data.success && res.data.data.length){
              this.areaArr = res.data.data;
            }
        });
    },
    getIndustData(){
      let dataObj = {
            type: 'get',
            url: '/mcbw/dictionary_datas/industryCategory/data',
            obj: {
                
            }
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('行业数据');
            if(res.data.success && res.data.data.length){
              this.industArr = res.data.data;
            }
        });
    },
    getTable(){
        this.getTableStatus = false;
        let taskType = '';
        let dateType = '';
        switch (this.tableTit){
            case "巡查完成率":
                taskType = 'patrol'
                break;
            case "隐患处理率":
            case "隐患数量":
                taskType = 'hidden'
                break;
            case "培训完成率":
                taskType = 'train'
                break;
            case "演练完成率":
                taskType = 'drill'
                break;
        }

        switch (this.timeIndex) { //直接显示上月的数据，无需切换
            case 0:
                dateType = 'thisDay'
                break;
            case 1:
                dateType = 'thisWeek'
                break;
            case 2:
                dateType = 'thisMonth'
                break;
        }
        let dataObj = {
            type: 'get',
            url: '/mcbw/task_statistic/list',
            obj: {
                orgId: this.loginData.orgId,
                areaSid: this.areaId,
                industryCategory: this.industId,
                taskType: taskType,
                dateType: dateType,
                currentPage: this.currentPage,
                pageSize: 50,
            }
        }
        if(this.tableTit == '巡查完成率'){
            dataObj.obj['planPeriodType'] = "planPeriodType";
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('表格详情');
            this.getTableStatus = true;
            if(res.data.success){
                if(res.data.totalCount){
                    this.totalCount = res.data.totalCount;
                }
                if(!res.data.data.length){
                    return;
                }
                this.tableList = [...this.tableList, ...res.data.data];
                let _this = this;
                this.$nextTick(()=>{
                    $JQ('#rightTop').mCustomScrollbar({
                        callbacks: {
                            onTotalScroll: function () {
                                if ((_this.tableList.length == res.data.totalCount) || (res.data.data.length == 0)) {
                                    console.log('没有更多数据');
                                    return;
                                } else {
                                    console.log('加载更多');
                                    _this.currentPage += 1;
                                    _this.getTable();
                                }
                            }
                        }
                    });
                });
            }
        });
    }
  }
}
</script>
<style lang="scss" scoped>
.layer-tem{
    position: absolute;
    left: 500px;
    bottom: 0;
    width: calc(100% - 1000px);
    padding: 30px 25px;
    border-radius: 4px;
    background: rgba(6,18,44,1) url('../../assets/img/maskBg.png') center center/101% 102% no-repeat;
    z-index: 12;
    // 关闭按钮
    .close-btn{
        position: absolute;
        width: 16px;
        height: 16px;
        right: 0;
        top: 0;
        right: 10px;
        top: 10px;
        cursor: pointer;
    }
    .select-wrap{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .tit{
        width: 200px;
        margin: 10px 0;
        text-indent: 8px;
    }
    .table-wrap{
        height: 400px;
        display: flex;
        flex-direction: column;
        .table-head{
            background: #0C2745;
            color: #7DB4DB;
            table th{
                height: 30px;
            }
        }
        .table-body{
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            color: #E4EFF5;
            /deep/ .mCSB_scrollTools{
                right: 0!important;
                .mCSB_dragger{
                    background: rgba(255,255,255,.3);
                    border-radius: 8px;
                    .mCSB_dragger_bar{
                        width: 8px;
                    }
                }
                .mCSB_draggerRail{
                    background-color: transparent;
                }
            } 
            table td{
                text-align: center;
                height: 30px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                i{
                cursor: pointer;
                }
                i.imgView {
                    color: rgba(8, 244, 247, .7);
                    cursor: pointer;
                    &.active {
                        color: rgba(8, 244, 247, .3);
                        cursor: default;
                    }
                }
                .td-option-wrap {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    i {
                        margin: 0 10px;
                        color: rgba(8, 244, 247, .3);
                        cursor: default;
                        &.active {
                            color: rgba(8, 244, 247, .7);
                            cursor: pointer;
                        }
                    }
                }
            }
            table tr:nth-child(2n){
              background: #0C2745;
            }
            .no-data{
                height: 368px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ddd;
            }
        }

        table{
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layer/rightBot.vue